'use strict';

var modules_auth_createLoggedInFetch_index = require('../../create-logged-in-fetch/index.js');
var modules_auth_internal_constants = require('../constants.js');
require('../../../../_rollupPluginBabelHelpers-D-dvSLAU.js');

/**
 * Wrap a fetch function to automatically add the Authorization header
 *   based on the JWT token in localStorage at {@see INTERNAL_AUTH_TOKEN_LOCAL_KEY}.
 *
 * Wraps {@see createLoggedInFetch}.
 *
 * @param options - {@see CreateInternalLoggedInFetchOptions}
 */
var createInternalAuthLoggedInFetch = function createInternalAuthLoggedInFetch(_ref) {
  var fetchFunction = _ref.fetchFunction;
  return modules_auth_createLoggedInFetch_index.createLoggedInFetch({
    fetchFunction: fetchFunction,
    getJwtToken: function getJwtToken() {
      return localStorage[modules_auth_internal_constants.INTERNAL_AUTH_TOKEN_LOCAL_KEY];
    }
  });
};

exports.createInternalAuthLoggedInFetch = createInternalAuthLoggedInFetch;
//# sourceMappingURL=index.js.map
